//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { APR, ERC20Wei, timestampToUTCDateString, timestampToUTCTimeString } from '@shared/conversions'
import { yupApr, yupErc20WeiRequired, yupEthAddrRequired, yupTxHashRequired } from '@shared/Enums'
import { EthAddr, ReportingColumnVisibilityEnum, StringTypeEnum, toFieldMetaData } from '@shared/SchemaTypes'
import * as yup from 'yup'
import { InferType } from 'yup'
import { ZeroAddress } from 'ethers'

const SierraReservesSchemaValues = {
  id: yup
    .string()
    .label('PoolEventId ')
    .required()
    .meta(
      toFieldMetaData({
        propName: 'id',

        description: 'ID of event ',
        stringType: StringTypeEnum.ID,
      })
    ),

  poolAddr: yupEthAddrRequired
    .label('Vault Address')
    .required()
    .default(ZeroAddress)
    .meta(
      toFieldMetaData({
        propName: 'poolAddr',
        columnVisibility: ReportingColumnVisibilityEnum.DefaultVisible,
        columnOrder: 2,
        columnWidth: 150,
        description: 'The smart-contract address of the loan vault. ',
        stringType: StringTypeEnum.ETH_ADDR,
      })
    ),

  poolToken: yup
    .string()
    .label('Token')
    .default(' ')
    .required()
    .meta(
      toFieldMetaData({
        propName: 'poolToken',
        columnVisibility: ReportingColumnVisibilityEnum.DefaultVisible,
        columnOrder: 3,
        columnWidth: 70,
        description: 'Token the Loan Vault',
      })
    ),

  poolName: yup
    .string()
    .label('Asset Type')
    .default(' ')
    .required()
    .meta(
      toFieldMetaData({
        propName: 'poolName',
        columnVisibility: ReportingColumnVisibilityEnum.DefaultVisible,
        columnOrder: 4,
        description: 'Name of the Loan Vault',
      })
    ),

  apy: yupApr
    .required()
    .default('0')
    .label('APY')
    .meta(
      toFieldMetaData({
        propName: 'apy',
        columnVisibility: ReportingColumnVisibilityEnum.DefaultVisible,
        columnOrder: 5,
        columnWidth: 80,
        description: ' The indicative loan fee rate in basis points ',
        stringType: StringTypeEnum.APR,
      })
    ),

  poolBalance: yupErc20WeiRequired
    .label('Holdings')
    .required()
    .default('0')
    .meta(
      toFieldMetaData({
        propName: 'poolBalance',
        columnVisibility: ReportingColumnVisibilityEnum.DefaultVisible,
        columnOrder: 6,
        columnWidth: 110,
        description: 'poolBalance ',
        stringType: StringTypeEnum.PPT_SHARES,
      })
    ),

  assets: yupErc20WeiRequired
    .label('Value')
    .required()
    .default('0')
    .meta(
      toFieldMetaData({
        propName: 'assets',
        columnVisibility: ReportingColumnVisibilityEnum.DefaultVisible,
        columnOrder: 7,
        columnWidth: 110,
        description: 'assets ',
        stringType: StringTypeEnum.STABLE_COINS,
      })
    ),

  percentReserves: yup
    .number()
    .required()
    .default(0)
    .label('% of Reserves')
    .meta(
      toFieldMetaData({
        propName: 'Percent of reserves',
        columnVisibility: ReportingColumnVisibilityEnum.DefaultVisible,
        columnOrder: 8,
        columnWidth: 110,
        description: 'Percent of reserves',
        stringType: StringTypeEnum.APR,
      })
    ),
}

export const SierraReservesSchema = yup.object(SierraReservesSchemaValues)
// .label('PoolEventCTO')
// .meta(toFieldMetaData({ propName: 'PoolEventCTO', description: 'Vault Event' }))

export interface SierraReservesCTO {
  id: string
  poolAddr: EthAddr
  poolToken: string
  poolName: string

  apy: APR

  poolBalance: ERC20Wei
  assets: ERC20Wei

  percentReserves: number
}

type SierraReservesCTOInfer = InferType<typeof SierraReservesSchema>

export const _testASierraReserves: SierraReservesCTO = {} as unknown as SierraReservesCTOInfer
export const _testBSierraReserves: SierraReservesCTOInfer = {} as unknown as SierraReservesCTO
